module.exports = __webpack_public_path__ + "img/image1.50e7eeea.png";